import { Link } from 'react-router-dom';

export default function AdminIdeas() {
  return (
    <div className="admin-page">
      <Link to="/" className="back-link">← Back to Dashboard</Link>
      <h2>Ideas & Project Notes</h2>

      <section className="idea-section">
        <h3>UMT-ClientOps - Client Lifecycle Management</h3>
        <p className="idea-status">Status: Planning</p>

        <h4>Overview</h4>
        <p>
          A comprehensive client lifecycle management system that tracks clients from prospect
          through customer, monitoring their service provisioning across all platforms.
        </p>

        <h4>Client Lifecycle Stages</h4>
        <div className="idea-diagram">
          <pre>{`
┌──────────┐    ┌──────────┐    ┌──────────┐    ┌─────────────────────┐
│ PROSPECT │ →  │ASSESSMENT│ →  │ CUSTOMER │ →  │ SERVICE MONITORING  │
└──────────┘    └──────────┘    └──────────┘    └─────────────────────┘

HubSpot: ✓      HubSpot: ✓      HubSpot: ✓      Track services:
Autotask: ✓     Autotask: ✓     Autotask: ✓     • Datto RMM
(Prospect)      (Prospect)      (Customer)      • Datto EDR/AV
                ITGlue: ✓                       • SaaS Alerts
                SecureScan: ✓                   • SaaS Backups (M365/GSuite)
                                                • Acronis
                                                • RocketCyber
                                                • Dark Web ID
                                                • BullPhish ID
                                                • Inky
                                                • SpamHero
          `}</pre>
        </div>

        <h4>Integrations Needed</h4>
        <table className="idea-table">
          <thead>
            <tr>
              <th>Service</th>
              <th>API Available</th>
              <th>Existing Code</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>HubSpot</td>
              <td>✅ Yes</td>
              <td>UMT-SecureScan</td>
              <td>Company search/create</td>
            </tr>
            <tr>
              <td>Autotask</td>
              <td>✅ Yes</td>
              <td>AutoTask-Hub</td>
              <td>Company CRUD, full client</td>
            </tr>
            <tr>
              <td>ITGlue</td>
              <td>✅ Yes</td>
              <td>ITGlue-Monitor, LLMVault</td>
              <td>Org create, no sync trigger API</td>
            </tr>
            <tr>
              <td>Datto RMM</td>
              <td>✅ Yes</td>
              <td>UMT-ServerHealth</td>
              <td>Site create, OAuth flow ready</td>
            </tr>
            <tr>
              <td>Datto EDR</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>SaaS Alerts</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>Acronis</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>RocketCyber</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>Dark Web ID</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>BullPhish ID</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>Inky</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
            <tr>
              <td>SpamHero</td>
              <td>🔍 Research</td>
              <td>-</td>
              <td>Need to investigate API</td>
            </tr>
          </tbody>
        </table>

        <h4>Key Features</h4>
        <ul>
          <li><strong>Pipeline View:</strong> Prospects → Assessment → Customer stages</li>
          <li><strong>Client Intake Form:</strong> Typeahead search HubSpot, create if new</li>
          <li><strong>Service Selection:</strong> Which services client is subscribing to</li>
          <li><strong>Provisioning Monitor:</strong> Poll all services, detect gaps</li>
          <li><strong>HUD Widget:</strong> Show provisioning gaps on dashboard</li>
        </ul>

        <h4>Sync Limitations</h4>
        <ul>
          <li><strong>ITGlue ↔ Autotask:</strong> No API to trigger sync - must use manual UI or enable two-way sync</li>
          <li><strong>Datto RMM ↔ Autotask:</strong> No API to trigger - must use "Run New Analysis" in UI</li>
          <li><strong>Workaround:</strong> Provide links to manual sync pages, poll APIs to detect when synced</li>
        </ul>

        <h4>Project Structure (Proposed)</h4>
        <div className="idea-diagram">
          <pre>{`
UMT-ClientOps/
├── api/
│   ├── hubspot/
│   │   ├── searchCompanies.ts
│   │   └── createCompany.ts
│   ├── autotask/
│   │   └── createCompany.ts
│   ├── sync/
│   │   ├── checkItglue.ts
│   │   └── checkDattoRmm.ts
│   └── widget-summary.ts
├── frontend/
│   ├── pages/
│   │   ├── Pipeline.tsx
│   │   ├── ClientIntake.tsx
│   │   └── ProvisioningStatus.tsx
│   └── components/
└── docs/
          `}</pre>
        </div>
      </section>

      <section className="idea-section">
        <h3>Future Ideas</h3>
        <ul>
          <li>Automated client offboarding workflow</li>
          <li>Service usage/billing reconciliation</li>
          <li>Client health score dashboard</li>
        </ul>
      </section>
    </div>
  );
}
